import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import FeatherIcon from "feather-icons-react";
import Table from "../../../core/common/dataTable/index";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import Loader from "../../../core/common/selfLoder";
import ODReportDetails from "./odReportDetails";
import { getFinancialYearList } from "../../../core/common/financialYear";

const ODReport = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [empname, setEmpname] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [showReport, setShowReport] = useState(false);

  const fyList = getFinancialYearList();

  const [empData, setEmpData] = useState({
    financial_year: "",
    from_date: "",
    to_date: "",
    employee_id: "",
    status: "",
  });

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());
  useEffect(() => {
    setEmpData((prevData) => ({
      ...prevData,
      financial_year: finance_year,
    }));
  }, []);

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };
  const columns = [
    {
      title: "EmpCode",
      dataIndex: "employee_id",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setEmpname(record.employee_name);
            setSelectedEmployeeId(record.employee_id);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text: string, record: any) => (
        <Link
          to="#"
          onClick={() => {
            setEmpname(record.employee_name);
            setSelectedEmployeeId(record.employee_id);
            setModalOpen(false);
          }}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          data-bs-dismiss="modal"
        >
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation", // Change From to designation
      sorter: (a: any, b: any) => a.designation.localeCompare(b.designation),
    },
    {
      title: "Department",
      dataIndex: "department", // Change To to department
      sorter: (a: any, b: any) => a.department.localeCompare(b.department),
    },
    {
      title: "Locatation",
      dataIndex: "branch_name", // Change To to branch_name
      sorter: (a: any, b: any) => a.branch_name.localeCompare(b.branch_name),
    },
  ];

  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });
  const data = teamData?.data;

  const getInputData = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEmpData({ ...empData, [name]: value });
  };

  const {
    data: odReportData,
    loading: odReportLoading,
    error: odReportError,
    callApi: postODReport,
  } = useApi("/api/manager/od-report", {
    method: "POST",
    autoCall: false,
  });
  const postData = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    const payload = {
      ...empData,
      employee_id: selectedEmployeeId,
    };
    try {
      const response = await postODReport(payload);
      console.log(response);
      if (response?.success) {
        if (response?.data?.length == 0) {
          Swal.fire({
            icon: "warning",
            title: "No Records Found",
            text:
              response?.message ||
              "No data was returned for the selected criteria.",
          });
        } else {
          setReportData(response?.data || []);
          setShowReport(true);
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong while fetching the report.",
      });
    }
  };

  return (
    <>
      <Loader loading={teamLoading || odReportLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Out Duty Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">OD</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.teamOutDutyGrid}>Team Out Duty</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Out Duty Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            {!showReport ? (
              <div className="card-body">
                <form onSubmit={postData}>
                  <div className="row">
                    {/* Financial Year */}
                    <div className="mb-2 col-md-4">
                      <label htmlFor="year" className="form-label">
                        Financial Year <sup className="text-danger">*</sup>
                      </label>

                      <select
                        id="year"
                        name="financial_year"
                        className="form-control"
                        value={empData.financial_year}
                        onChange={(e: any) => { setEmpData({ ...empData, financial_year: e.target.value }) }}
                      >
                        {getFinancialYearList().map((fy) => (
                           <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        <strong>
                          Date From<sup className="text-danger">*</sup>
                        </strong>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{ format: "DD-MM-YYYY", type: "mask" }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          name="from_date"
                          value={
                            empData.from_date
                              ? dayjs(empData.from_date, "YYYY-MM-DD")
                              : null
                          }
                          onChange={(date) => {
                            const newFromDate = date
                              ? date.format("YYYY-MM-DD")
                              : "";

                            setEmpData((prev) => {
                              const currentToDate = dayjs(
                                prev.to_date,
                                "YYYY-MM-DD"
                              );

                              // Clear `to_date` if it's before the newly selected `from_date`
                              const shouldClearToDate =
                                prev.to_date &&
                                date &&
                                currentToDate.isBefore(date, "day");

                              return {
                                ...prev,
                                from_date: newFromDate,
                                to_date: shouldClearToDate ? "" : prev.to_date,
                              };
                            });
                          }}
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        <strong>
                          Date To<sup className="text-danger">*</sup>
                        </strong>
                      </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{ format: "DD-MM-YYYY", type: "mask" }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                          name="to_date"
                          value={
                            empData.to_date
                              ? dayjs(empData.to_date, "YYYY-MM-DD")
                              : null
                          }
                          onChange={(date) =>
                            setEmpData((prev) => ({
                              ...prev,
                              to_date: date ? date.format("YYYY-MM-DD") : "",
                            }))
                          }
                          disabledDate={(current: any) => {
                            const fromDate = dayjs(
                              empData.from_date,
                              "YYYY-MM-DD"
                            );
                            if (!empData.from_date) {
                              return true;
                            }
                            return current && current.isBefore(fromDate);
                          }}
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>

                    {/* Employee Name Search */}
                    <div className="col-md-6 mb-2">
                      <label className="mb-2" htmlFor="employeeSearch">
                        <strong>Employee Name:</strong>
                      </label>

                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="empname"
                          id="employeeSearch"
                          className="form-control"
                          placeholder="Type name / code"
                          style={{ width: "100%" }}
                          value={empname} // This shows the name in the input
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const value = e.target.value;
                            setEmpname(value); // This is for display
                            setSelectedEmployeeId(""); // Reset selected ID

                            if (value.trim()) {
                              const matches = data.filter((item: any) =>
                                item.employee_name
                                  .toLowerCase()
                                  .includes(value.toLowerCase())
                              );
                              setFilteredSuggestions(matches);
                              setShowSuggestions(true);
                            } else {
                              setFilteredSuggestions([]);
                              setShowSuggestions(false);
                            }
                          }}
                        />

                        {/* Modal button */}
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "8px",
                            transform: "translateY(-50%)",
                            padding: "4px 8px",
                          }}
                          onClick={() => setModalOpen(true)}
                          data-bs-toggle="modal"
                          data-bs-target="#bs-example-modal-lg"
                        >
                          <FeatherIcon icon="more-horizontal" size="16" />
                        </button>

                        {/* Suggestions */}
                        {showSuggestions && filteredSuggestions.length > 0 && (
                          <ul
                            className="dropdown-menu show"
                            style={{
                              width: "100%",
                              maxHeight: "200px",
                              overflowY: "auto",
                              position: "absolute",
                              zIndex: 1000,
                            }}
                          >
                            {filteredSuggestions.map((item, index) => (
                              <li
                                key={index}
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEmpname(item.employee_name);
                                  setSelectedEmployeeId(item.employee_id);
                                  setShowSuggestions(false);
                                }}
                              >
                                {item.employee_id} - {item.employee_name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-2 col-md-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <select
                        id="status"
                        name="status"
                        onChange={getInputData}
                        className="form-select"
                      >
                        <option value="">--Select--</option>

                        <option value="PENDING">Pending</option>
                        <option value="APPROVED">Approved</option>
                        <option value="REJECTED">Rejected</option>
                      </select>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="d-flex flex-column align-items-end mt-3">
                    {/* Generate Report Button */}
                    <button type="submit" className="btn btn-primary custom_button">
                      Generate Report
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <div className="card-body">
                <ODReportDetails
                  data={reportData || []}
                  onBack={() => setShowReport(false)}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${modalOpen ? "show" : ""}`}
        id="bs-example-modal-lg"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden={!modalOpen}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <img
                src="/assets/img/logo/weconnectlogo.png"
                alt=""
                style={{ height: "50px" }}
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalOpen(false)}
              />
            </div>
            <div className="modal-body">
              <div className="card-body p-0">
                <Table dataSource={data} columns={columns} Selection={false} showSearchInput={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ODReport;
